/*
 * Collection page behaviour:
 *  - Sort dropdown: submit the form (reload with ?sort_by=) on change.
 *  - Colour / size selection on cards lives in assets/0-variant-options.js.
 * Quick-add "+" is handled by Horizon's <product-form-component> (AJAX cart).
 */
(function () {
  function initSort(root) {
    root.querySelectorAll('[data-col-sort]').forEach(function (form) {
      var sel = form.querySelector('select[name="sort_by"]');
      if (!sel || sel.dataset.colBound) return;
      sel.dataset.colBound = '1';
      sel.addEventListener('change', function () { form.submit(); });
    });
  }

  function init(root) {
    root = root || document;
    initSort(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
})();
